import React from "react";
import Image from "next/image";

interface NextImageProps {
  src: string;
  alt: string;
  width?: number | `${number}`;
  height?: number | `${number}`;
  size?: string;
  style?: React.CSSProperties;
  className?: string;
  quality?: number | `${number}`;
  title?: string;
  priority?: boolean;
  loading?: "eager" | "lazy";
  unoptimized?: boolean;
}

export const NextImage = ({
  src,
  width,
  height,
  alt,
  size,
  style,
  className,
  title,
  quality,
  priority,
  loading,
  unoptimized,
}: NextImageProps) => {
  const finalLoading = loading || (priority ? "eager" : "lazy");
  const isSvg = typeof src === "string" && src.toLowerCase().endsWith(".svg");

  return (
    <Image
      className={className}
      src={src}
      width={width}
      height={height}
      alt={alt}
      sizes={size || undefined}
      style={style}
      quality={quality}
      title={title}
      priority={priority}
      loading={finalLoading}
      unoptimized={unoptimized || isSvg}
    />
  );
};
